/** All valid match type keys for set lottery (Thai Set & Lao Set) */
export type SetLotteryMatchType =
  | '6_digit_match'
  | '5_digit_match'
  | '4_digit_match'
  | '4_digit_exact'
  | '3_digit_exact'
  | '4_digit_tod'
  | '3_digit_tod'
  | 'front_3_digit'
  | 'front_2_digit'
  | 'last_2_digit'
  | 'no_match'

/** All valid raw bet type keys used for internal logic routing */
export type RawBetType =
  | 'bet_three_tod'
  | 'bet_three_top'
  | 'bet_three_front'
  | 'bet_three_front_tod'
  | 'bet_two_top'
  | 'bet_two_under'
  | 'bet_two_tod'
  | 'bet_run_top'
  | 'bet_run_bottom'
  | 'bet_four'
  | 'bet_six'
  | 'bet_thai_set'
  | 'bet_lao_set'

/** Format a match type key into a simple display label (e.g. '6_digit_match' → '6 Digit Match') */
export function formatMatchType(matchType: string): string {
  return matchType.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

/**
 * Mask digit positions in a winning number with 'X' to indicate wildcard positions.
 * Used by both Thai Set and Lao Set to format winning number displays.
 *
 * Examples:
 *   maskWinningNumber('361807', 1, 'leading')  → 'X61807'  (5-digit match)
 *   maskWinningNumber('361807', 2, 'leading')  → 'XX1807'  (4-digit match)
 *   maskWinningNumber('4182', 1, 'trailing')   → '418X'    (front 3 digits)
 *   maskWinningNumber('4182', 2, 'leading')    → 'XX82'    (last 2 digits)
 */
export function maskWinningNumber(
  number: string,
  maskCount: number,
  position: 'leading' | 'trailing' = 'leading',
): string {
  if (position === 'trailing') {
    return number.slice(0, number.length - maskCount) + 'X'.repeat(maskCount)
  }
  return 'X'.repeat(maskCount) + number.slice(maskCount)
}

/** Check whether a raw bet type is a set lottery type */
export function isSetLotteryBetType(
  rawBetType: string | undefined,
): rawBetType is 'bet_thai_set' | 'bet_lao_set' {
  return rawBetType === 'bet_thai_set' || rawBetType === 'bet_lao_set'
}
